import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"



/* Blog*/

// Handle retrieve all blogs
export const handleRetrieveWebinars = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      type: data?.type || null,
      limit: data?.limit || null,
      search: data?.search || null,
      endDate: data?.endDate || null,
      topicId: data?.topicId || null,
      startDate: data?.startDate || null,
      currentPage: data?.currentPage || null,
      specialistName: data?.specialistName || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/public/webinar/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve single blog
export const handleRetrieveSingleWebinar = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/public/webinar/retrieve/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)